export const DEFAULT_EMAIL = "hola@vecinos.com";
